import { render, staticRenderFns } from "./LandingChristmasES.vue?vue&type=template&id=2eec78fe&scoped=true"
import script from "./LandingChristmasES.vue?vue&type=script&lang=js"
export * from "./LandingChristmasES.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eec78fe",
  null
  
)

export default component.exports